// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"725":"b39459d7","778":"bbf5c674"}[chunkId] + ".chunk.css";
};